import {ApiUrl} from "../../../auth/authMethods";
import {useState} from "react";
import axios from "axios";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";

export default function DownloadUserReport({filter}){

    const url = ApiUrl + '/user/report'

    const [loading, setLoading] = useState(false)

    const handleClick = () => {
        setLoading(true)

        const queryParams = new URLSearchParams(filter).toString();

        const axiosConfig = {
            method: 'get',
            url: url+ "?" + queryParams,
            responseType: 'blob'
        };

        // Realiza a requisição Axios
        axios(axiosConfig)
            .then(response => {
                // Cria um objeto URL para o blob
                const blobUrl = URL.createObjectURL(response.data);

                // Cria um link para download
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = 'relatorio-usuarios.xlsx';

                // Adiciona o link ao corpo do documento
                document.body.appendChild(link);

                // Simula um clique no link para iniciar o download
                link.click();

                // Remove o link do corpo do documento após o download
                document.body.removeChild(link);
            })
            .catch(error => console.error('Erro ao gerar relatório:', error))
            .finally(() => {
                setLoading(false)
            })
    }


    return <span className="button-show" style={{cursor: "pointer", marginRight: "1%"}}>
        <LoadingButton
            onClick={handleClick}
            loading={loading}
            loadingPosition="start"
            startIcon={<SaveIcon/>}
            variant="contained"
            className={''}
        >
            <span>
                &nbsp;Baixar Relatório
            </span>
        </LoadingButton>
    </span>
}